(ns app.front.view.payment.moneris-co
  "Moneris Checkout embebbed form. When initialized with the ticket received from the original preload request it embeds a form in an iframe.
   The form handles all checkout operations and reports the progress through callbacks."
  (:require [app.front.entities :as entities]
            [app.front.util :as futil]
            [app.front.view.payment.checkout :as checkout]
            [core.front.carbon :as cc]
            [core.front.event :refer [>evt]]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(defn return-to-workspace [workspace-id]
  [::navigate-to-workspace workspace-id])

(rf/reg-event-fx ::navigate-to-workspace
  (fn [{:keys [db]} [_ workspace-id]]
    (checkout/return-nav-fx db :view/workspace {:workspace-id workspace-id})))


(rf/reg-event-fx
  ::get-payment-receipt
  (fn [_ [_ ticket payment-id workspace-id exit-moneris?]]
    {:fx [[:dispatch [:comm/command-monitored {:command    :payment/moneris-co-approved
                                               :data       {:ticket     ticket
                                                            :payment-id payment-id}
                                               :on-success [::get-payment-receipt.success workspace-id exit-moneris?]}]]]}))


(rf/reg-event-fx ::get-payment-receipt.success
  (fn [_ [_ workspace-id exit_moneris? status changes]]
    {:fx [(when exit_moneris? [:dispatch (return-to-workspace workspace-id)])
          [:dispatch [::entities/apply-changes status changes]]]}))


(defn parse-resp [string]
  (-> (.parse js/JSON string)
      (js->clj :keywordize-keys true)))


(defn cancel-transaction [^js checkout-inst {:keys [workspace-id]}]
  (. checkout-inst closeCheckout)
  (>evt (return-to-workspace workspace-id)))


(defn page-closed [^js checkout-inst]
  (. checkout-inst closeCheckout))


(defn receipt
  "This callback is only called if Moneris has been configured to show the order confirmation view. We fetch the receipt and transact the CP payment here.
   But we must make sure those are done even if the order configuration view is not configured. See complete-transaction. The checkout view is not exited as the user will do that (<-)."
  [{:keys [workspace-id ctx]} *receipt-entered? msg]
  (let [resp (parse-resp msg)]
    (when (= (:response_code resp) "001")
      (reset! *receipt-entered? true)
      (>evt [::get-payment-receipt (:ticket resp) (:payment-id ctx) workspace-id false]))))


(defn complete-transaction
  "There are two possibilities when this callback is called:
   1. If Moneris order confirmation view is configured, this callback is called once the user presses (<-) to exit Moneris Checkout. The receipt is therefore already fetched
   in receipt callback and should not be retried.
   2. If no order confirmation view, this is called immediately when the user has made the checkout. The receipt must be fetched now and the checkout view can be exited."
  [^js checkout-inst {:keys [workspace-id ctx]} *receipt-entered? msg]
  (let [resp (parse-resp msg)]
    (when (= (:response_code resp) "001")
      (. checkout-inst closeCheckout)
      (if @*receipt-entered?
        (>evt (return-to-workspace workspace-id))
        (>evt [::get-payment-receipt (:ticket resp) (:payment-id ctx) workspace-id true])))))


(defn embedded-form [{:keys [ctx] :as details}]
  (r/with-let [*receipt-entered? (r/atom false)]
    (r/create-class
      {:component-did-mount (fn [_]
                              (let [checkout-inst (js/monerisCheckout.)]
                                (doto checkout-inst
                                  (.setMode (:env ctx))
                                  (.setCheckoutDiv "checkout-div")
                                  (.setCallback "cancel_transaction" (partial cancel-transaction checkout-inst details))
                                  (.setCallback "page_closed" (partial page-closed checkout-inst))
                                  (.setCallback "payment_receipt" (partial receipt details *receipt-entered?))
                                  (.setCallback "payment_complete" (partial complete-transaction checkout-inst details *receipt-entered?))
                                  (.startCheckout (:ticket ctx)))))
       :reagent-render      (fn [_details]
                              [:div.flex.flex-col.items-center.h-full.w-full
                               [:div {:id "checkout-div"}]])})))


(defmethod checkout/payment-form :payment-service/moneris-co
  [details]
  [futil/js-loader
   {:id  "moneris-script"
    :src "/asset/js/moneris_co_v2.00.js"}
   (cc/progress-indicator-skeleton)
   [embedded-form details]])
